import styled from 'styled-components';

interface BoxProps {
  flex?: string;
  width?: string;
  height?: string;
  $m?: number;
  $ml?: number;
  $mr?: number;
  $mt?: number;
  $mb?: number;
  $mx?: number;
  $my?: number;
}

export const Box = styled.div<BoxProps>`
  flex: ${({ flex }) => flex};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin: ${({ $m = 0, $ml = 0, $mr = 0, $mt = 0, $mb = 0, $mx = 0, $my = 0 }) =>
    ($m && `${$m}px`) || ($mx && `0 ${$mx}px`) || ($my && `${$my}px 0`) || `${$mt}px ${$mr}px ${$mb}px ${$ml}px`};
`;

interface FlexProps {
  $justifyContent?: string;
  $alignItems?: string;
  $m?: number;
  $ml?: number;
  $mr?: number;
  $mt?: number;
  $mb?: number;
  $mx?: number;
  $my?: number;
}

export const Flex = styled.div<FlexProps>`
  display: flex;
  justify-content: ${({ $justifyContent }) => $justifyContent};
  align-items: ${({ $alignItems }) => $alignItems};
  margin: ${({ $m = 0, $ml = 0, $mr = 0, $mt = 0, $mb = 0, $mx = 0, $my = 0 }) =>
    ($m && `${$m}px`) || ($mx && `0 ${$mx}px`) || ($my && `${$my}px 0`) || `${$mt}px ${$mr}px ${$mb}px ${$ml}px`};
`;

export const FlexContainer = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  padding: 0 calc((100% - ${({ theme }) => theme.widthContainer}) / 2);

  @media screen and (max-width: 1200px) {
    padding: 0 30px;
  }
`;

export const BoxContent = styled(Box)`
  @media screen and (max-width: 1200px) {
    margin: 0;
  }
`;

export const FlexContent = styled(Flex)`
  flex-wrap: wrap;
  width: 100%;
  position: relative;
`;

interface ButtonProps {
  $margin?: string;
  $padding?: string;
  $border?: string;
  $bgColor?: string;
  $color?: string;
  $borderRadius?: string;
  $height?: string;
  $width?: string;
  $fontSize?: string;
  $transition?: string;
  $hoverColor?: string;
  $hoverBgColor?: string;
  $hoverBorder?: string;
}

export const Button = styled.button<ButtonProps>`
  margin: ${({ $margin }) => $margin || '0 0 0 20px'};
  padding: ${({ $padding }) => $padding || '10px 15px'};
  border: ${({ $border }) => $border || '2px solid #000'};
  background: ${({ $bgColor }) => $bgColor || '#eeeeee'};
  color: ${({ $color }) => $color || '#000'};
  cursor: pointer;
  border-radius: ${({ $borderRadius }) => $borderRadius || '5px'};
  height: ${({ $height }) => $height}; 
  width: ${({ $width }) => $width};  
  font-weight: bold;
  font-size: ${({ $fontSize }) => $fontSize};   
  white-space: nowrap;
  transition: ${({ $transition }) => $transition || '0.3s ease-in-out'};
  
  &:hover {
    color: ${({ $hoverColor }) => $hoverColor || '#fff'};
    background: ${({ $hoverBgColor }) => $hoverBgColor || '#3ea78d'};
    border: ${({ $hoverBorder }) => $hoverBorder || '2px solid #3ea78d'};
  }
`;